import type { RootState } from 'features/app/store/store';
import type { CaptionRequester } from 'features/call/call-captions/store';
import { isAcceptingUserSelector } from 'features/teaming/teaming-base/store';

/** Wire identity used on RNS caption-intent payloads (call-wide, not per-client). */
export type CaptionIntentParticipant = 'vi1' | 'vi2' | 'deafEndpoint';

export interface CaptionIntentPayload {
  type: 'caption-intent';
  requester: CaptionIntentParticipant;
  enabled: boolean;
}

// Accepting teammate is VI2; everyone else (solo call or requesting VI) is VI1.
export const selectLocalCaptionIntentParticipant = (
  state: RootState
): CaptionIntentParticipant => (isAcceptingUserSelector(state) ? 'vi2' : 'vi1');

/** Map call-wide vi1/vi2 onto this client's local vs remote request flags. */
export const toCaptionRequester = ({
  participant,
  localParticipant,
}: {
  participant: CaptionIntentParticipant;
  localParticipant: CaptionIntentParticipant;
}): CaptionRequester => {
  if (participant === 'deafEndpoint') {
    return 'deafEndpoint';
  }

  return participant === localParticipant
    ? 'localInterpreter'
    : 'remoteInterpreter';
};
